<template>
    <vue-better-new-scroll
        class="wrapper"
        ref="scroll"
        :scrollbar="scrollbarObj"
        :pullDownRefresh="pullDownRefreshObj"
        :startY="parseInt(startY)"
        @pullingDown="onPullingDown">
        <slot></slot>
    </vue-better-new-scroll>

</template>

<script>
import VueBetterNewScroll from '@/components/newscroll';
export default {
    name: 'scrollList',
    components: {VueBetterNewScroll},
    data() {
        return {
            scrollbarObj: {
                fade: true // 默认滚动条
            },
            pullDownRefreshObj: {
                threshold: 40,
                stop: 32,
                txt: '刷新完成'
            },
            startY: 0, // 纵轴方向初始化位置
            items: []
        };
    },
    methods: {
        onPullingDown(callBack) {
            this.$emit('onPullingDown', this.$refs.scroll);
        },
    }
};
</script>
<style  lang="scss" scoped>
.wrapper{
    position: fixed;
    height: 100%;
    width: 100%;
    // overflow: hidden;
    overflow: scroll;
    left: 0;
}
</style>
